










































import { defineComponent, ref, onMounted } from "@nuxtjs/composition-api";
import PBHelper from "~/components/PageBuilder/utils/helper";
import PBComponent from "~/components/PageBuilder/utils/component";
import { isEmpty } from "lodash-es";
const { loadAsyncComponent } = PBComponent();

export default defineComponent({
  name: "LayoutTabs",
  components: {
    ...loadAsyncComponent(),
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
    dynamicBlocks: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { getComponentName } = PBHelper();
    const navigations = ref([]);
    const tabsContent = ref([]);
    const getAttributes = (child, index) => child[index]?.attr;
    const getChildComponents = (column) => column.child;
    const activeTab = (i) => {
      if (!isEmpty(navigations.value)) {
        navigations.value.forEach(function (element, index) {
          if (index === i) {
            element.attr.class = "tab-header ui-state-active";
          } else {
            element.attr.class = "tab-header";
          }
        });
      }
      if (!isEmpty(tabsContent.value)) {
        tabsContent.value.forEach(function (element, index) {
          if (index === i) {
            element.show = true;
          } else {
            element.show = false;
          }
        });
      }
    };

    onMounted(async () => {
      navigations.value = props.children[0]?.["child"];
      tabsContent.value = props.children[1]?.["child"];
      activeTab(0);
    });

    return {
      navigations,
      tabsContent,
      getComponentName,
      getChildComponents,
      activeTab,
      getAttributes,
    };
  },
});
